import React from 'react';
import AccountForm from './AccountForm';
import {sectionStyles} from '../../styles/sectionStyles';
import {withStyles} from '@material-ui/core';
import {Redirect} from 'react-router-dom';
import {connect} from "react-redux";
import {compose} from 'redux';

class AccountCreate extends React.Component {
  render() {
    const {classes, auth} = this.props;

    if (!auth.accessToken) {
      return <Redirect to='/signin' />
    }

    return (
        <AccountForm className={classes.wrapperSection}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default compose(
    connect(mapStateToProps),
    withStyles(sectionStyles)
)(AccountCreate);